export const isString = (item: string | undefined): item is string => {
  return !!item;
};
